import style from './style'
import { createUseStyles } from 'react-jss'
import {
  TypographyElement,
  RadioButton,
  Skeleton,
  Icon,
  Icons
} from 'UI'
import {
  masterCardLogo,
  paypalLogo,
  visaLogo,
  carteNationale
} from 'assets'

export const cardTypes = {
  Visa: 1,
  Mastercard: 2,
  PayPal: 7,
  CmiCard: 9
}

const cardTypesImages = {
  1: visaLogo,
  2: masterCardLogo,
  7: paypalLogo,
  9: carteNationale
}

const LoadingCreditCards = () => <Skeleton lines={1} height={63} width='100%' margin='0 0 16px 0' />

export default ({ card, changeDefaultPaymentMethodAction, deleteCard, deletePaypal }) => {
  const useStyles = createUseStyles(style)
  const {
    savedCardsRoot,
    savedCard,
    removeCreditCardIcon,
    row,
    cardImage,
    cardNameClass
  } = useStyles(card)
  return card.loading
    ? <LoadingCreditCards />
    : (
      <div className={savedCardsRoot}>
        <div className={savedCard}>
          <div className={row}>
            <RadioButton name='creditCards' label='' checked={card.IsDefault} handleChange={() => changeDefaultPaymentMethodAction(card.Id)} />
            <img src={cardTypesImages[card.PaymentMethodType]} alt='cardImg' className={cardImage} />
            <TypographyElement
              component='p'
              variant='body2'
              spacing='0 0 0 16px'
              className={cardNameClass}
            >
              {`${card.PaymentMethodType !== cardTypes.PayPal ? '****-' : ''}${card.Name}`}
            </TypographyElement>
          </div>
          {
            !card.IsDefault
              ? <Icon iconName={Icons.bin} style={removeCreditCardIcon} onHandleIconClick={() => card.PaymentMethodType === cardTypes.PayPal ? deletePaypal(card) : deleteCard(card)} />
              : null
          }
        </div>
      </div>
      )
}
